import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Injector,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorConnector } from '../control-value-accessor-connector';

@Component({
  selector: 'ms-percentage-input',
  templateUrl: './ms-percentage-input.component.html',
  styleUrls: ['./ms-percentage-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: MsPercentageInputComponent,
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MsPercentageInputComponent extends ControlValueAccessorConnector {
  @Input() min: number = 0;
  @Input() max: number;
  @Input() styleClass: string;
  @Input() maxLength: number;
  @Input() formControlName: string;

  constructor(injector: Injector) {
    super(injector);
  }
}
